import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const getAdminDashboard = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN.DASHBOARD);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch admin dashboard:", error);
    throw error;
  }
};

export const getCategoriesList = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN.CATEGORIES_LIST);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch categories:", error);
    throw error;
  }
};

export const getProfessionsList = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN.PROFESSIONS_LIST);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch professions:", error);
    throw error;
  }
};

export const createCategory = async (payload) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.ADMIN.CREATE_CATEGORY,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create category:", error);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const response = await apiClient.delete(
      `${API_ENDPOINTS.ADMIN.DELETE_CATEGORY}${categoryId}/` // Use your ADMIN constants here!
    );
    return response.data;
  } catch (error) {
    console.error("Failed to delete category:", error);
    throw error;
  }
};

// Create a new profession
export const createProfession = async (payload) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.PROFESSIONS_CREATE, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to create profession:", error);
    throw error;
  }
};

export const getPlatformServicesList = async () => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.ADMIN.PLATFORM_SERVICES_LIST
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch platform services:", error);
    throw error;
  }
};

export const createPlatformService = async (payload) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.ADMIN.PLATFORM_SERVICE_CREATE,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create platform service:", error);
    throw error;
  }
};

export const getUsersList = async (params = {}) => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.ADMIN.USERS,
      {
        params
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to fetch users:", error);
    throw error;
  }
};